var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSchedule(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.6875 13.125C8.99527 13.125 8.31858 12.9197 7.74301 12.5351C7.16743 12.1506 6.71883 11.6039 6.45392 10.9644C6.18902 10.3249 6.1197 9.62112 6.25475 8.94219C6.3898 8.26325 6.72314 7.63961 7.21263 7.15013C7.70211 6.66064 8.32575 6.3273 9.00469 6.19225C9.68362 6.0572 10.3874 6.12652 11.0269 6.39142C11.6664 6.65633 12.2131 7.10493 12.5976 7.68051C12.9822 8.25608 13.1875 8.93277 13.1875 9.625C13.1875 10.5533 12.8188 11.4435 12.1624 12.0999C11.506 12.7563 10.6158 13.125 9.6875 13.125ZM9.6875 7C9.16833 7 8.66081 7.15396 8.22913 7.44239C7.79745 7.73083 7.461 8.1408 7.26232 8.62046C7.06364 9.10011 7.01165 9.62791 7.11294 10.1371C7.21423 10.6463 7.46423 11.114 7.83135 11.4812C8.19846 11.8483 8.66619 12.0983 9.17539 12.1996C9.68459 12.3008 10.2124 12.2489 10.692 12.0502C11.1717 11.8515 11.5817 11.5151 11.8701 11.0834C12.1585 10.6517 12.3125 10.1442 12.3125 9.625C12.3125 8.92881 12.0359 8.26113 11.5437 7.76885C11.0514 7.27656 10.3837 7 9.6875 7Z",
    fill: "#D6D6D6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3831 10.9375L9.25 9.80438V7.875H10.125V9.44563L11 10.3206L10.3831 10.9375Z",
    fill: "#D6D6D6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 2.625C12.75 2.39294 12.6578 2.17038 12.4937 2.00628C12.3296 1.84219 12.1071 1.75 11.875 1.75H10.125V0.875H9.25V1.75H5.75V0.875H4.875V1.75H3.125C2.89294 1.75 2.67038 1.84219 2.50628 2.00628C2.34219 2.17038 2.25 2.39294 2.25 2.625V11.375C2.25 11.6071 2.34219 11.8296 2.50628 11.9937C2.67038 12.1578 2.89294 12.25 3.125 12.25H4.875V11.375H3.125V2.625H4.875V3.5H5.75V2.625H9.25V3.5H10.125V2.625H11.875V5.25H12.75V2.625Z",
    fill: "#D6D6D6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchedule);
export default __webpack_public_path__ + "static/media/schedule.5d692921d3ef0364fcde20d8e2eabda6.svg";
export { ForwardRef as ReactComponent };